import { cn } from "@/lib/utils"
import { useUI } from "@/hooks/useUI"
import { ItemSummary } from "@/features/equipment/types/product"
import { ITEM_STATUSES } from "@/constants/item"

const defaultSummary: ItemSummary = {
  total: 0,
  available: 0,
  inUse: 0,
  maintenance: 0,
  missing: 0,
  retired: 0,
}

type ItemSummaryStatsProps = {
  summary?: ItemSummary
  className?: string
  showRetired?: boolean
}


export function ItemSummaryStats({
  summary = defaultSummary,
  className,
  showRetired = false,
}: ItemSummaryStatsProps) {
  const { itemStatuses, getEnumLabel } = useUI()

  const items = [
    {
      status: ITEM_STATUSES[0],
      value: summary.available,
      className: "bg-success/10",
    },
    {
      status: ITEM_STATUSES[1],
      value: summary.inUse,
      className: "bg-info/10",
    },
    {
      status: ITEM_STATUSES[2],
      value: summary.maintenance,
      className: "bg-warning/10",
    },
    {
      status: ITEM_STATUSES[3],
      value: summary.missing,
      className: "bg-destructive/10",
    },
    ...(showRetired
      ? [
          {
            status: "Retired",
            value: summary.retired,
            className: "bg-muted",
          },
        ]
      : []),
  ] as const

  return (
    <div
      className={cn(
        "mt-4 grid gap-1.5",
        showRetired ? "grid-cols-2 sm:grid-cols-5" : "grid-cols-2 sm:grid-cols-4",
        className
      )}
    >
      {items.map((item) => (
        <div
          key={item.status}
          className={cn(
            "flex flex-col items-center rounded px-1 py-1.5",
            item.className
          )}
        >
          <span className="text-xs font-bold text-foreground">
            {item.value}
          </span>

          <span className="text-[9px] text-muted-foreground text-center break-words">
            {getEnumLabel(itemStatuses, item.status)}
          </span>
        </div>
      ))}
    </div>
  )
}